export default __webpack_public_path__ + "static/media/icon_arrow_up_green.f56ab42e.svg";